import {
  IAPIAdminAccountDef,
  IAPIAdminAccountStatusDef,
  IAPIAdminRoleDef,
  IAPIAdminAccountProfileDef,
} from '../api_interfaces/core';
import { RSCUserPrivileges } from './RSCUserPrivileges';
import { RSCBase } from './base/RSCBase';

export class RSCAdminAccount extends RSCBase implements IAPIAdminAccountDef {
  id!: number;
  profile!: IAPIAdminAccountProfileDef;
  role!: IAPIAdminRoleDef;
  status!: IAPIAdminAccountStatusDef;
  _privileges!: RSCUserPrivileges; // { consolidated: any };

  get Id() {
    return this?.id || 0;
  }

  protected override _afterFill(data: any) {
    this._privileges = new RSCUserPrivileges({
      fillWith: data?._privileges || {},
    });
  }

  GetPrivileges() {
    return this._privileges || new RSCUserPrivileges({ fillWith: {} });
  }

  override toJSON(): any {
    return {
      id: this.id,
      role: this.role,
      profile: this.profile,
      status: this.status,
      _privileges: this._privileges,
    };
  }
}
